import { FetchStatus } from '@flatsy/types/FetchStatus'
import { unwrapResult } from '@reduxjs/toolkit'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'src/redux'
import { selectBookableSlots, Slot, syncBookableSlots } from 'src/redux/slices/BookableSlots'
import { BookableSlotsProps, BookableSlotsReturn } from './Type'

export const useBookableSlots = ({ assetId, agent }: BookableSlotsProps): BookableSlotsReturn => {
  const slots = useSelector<RootState, Slot[] | undefined>((state) => selectBookableSlots(state))
  const slotsStatus = useSelector<RootState, FetchStatus>((state) => state.bookableSlots.status)
  const dispatch: AppDispatch = useDispatch()
  const get = async (): Promise<Slot[] | undefined> => {
    if (assetId) {
      try {
        const result = await dispatch(syncBookableSlots({ assetId: assetId || '', agent }))
        const resultData = unwrapResult(result)
        return resultData
      } catch {
        //
        return undefined
      }
    }
  }
  useEffect(() => {
    get()
  }, [dispatch, assetId, agent])

  return { slots, slotsStatus, getBookables: get }
}
